var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircledPlane({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.3333,
    cy: 30.5,
    r: 30,
    fill: "#EEF2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9916 36.0079L21.075 34.4038C20.8611 34.2871 20.7398 34.1172 20.711 33.8939C20.6822 33.6707 20.7452 33.4809 20.9 33.3246L21.25 32.9746C21.3278 32.8968 21.4203 32.8432 21.5276 32.8136C21.635 32.7841 21.7369 32.7794 21.8333 32.7996L24.4 33.1496L28.95 28.5996L21.0166 24.2829C20.725 24.1274 20.555 23.8843 20.5068 23.5538C20.4586 23.2232 20.5508 22.9413 20.7833 22.7079L21.075 22.4163C21.2111 22.2802 21.362 22.1927 21.5276 22.1538C21.6933 22.1149 21.8633 22.1149 22.0375 22.1538L32.625 24.8663L37.2041 20.3454C37.5347 20.0149 37.9481 19.8496 38.4443 19.8496C38.9405 19.8496 39.3535 20.0149 39.6833 20.3454C40.0139 20.676 40.1791 21.0894 40.1791 21.5856C40.1791 22.0818 40.0139 22.4948 39.6833 22.8246L35.1333 27.3746L37.8458 37.9038C37.8847 38.0982 37.8796 38.288 37.8306 38.4731C37.7816 38.6582 37.6895 38.8184 37.5541 38.9538L37.4083 39.0996C37.1361 39.3718 36.8199 39.4788 36.4598 39.4204C36.0997 39.3621 35.8325 39.1677 35.6583 38.8371L31.4 31.0496L26.85 35.5996L27.2 38.1079C27.2194 38.2441 27.2097 38.3704 27.1708 38.4871C27.1319 38.6038 27.0639 38.7107 26.9666 38.8079L26.8208 38.9538C26.6264 39.1482 26.393 39.2307 26.1208 39.2011C25.8486 39.1716 25.6444 39.0308 25.5083 38.7788L23.9916 36.0079Z",
    fill: "#00525D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledPlane);
export default __webpack_public_path__ + "static/media/circled-plane.a093c8130fa22dfa3e01d8db9a9837ec.svg";
export { ForwardRef as ReactComponent };